




































import { Vue, Component, Prop } from 'vue-property-decorator';

import TwismLogoIcon from '@/components/icons/TwismLogo.vue';
import Typography from '@/componentsV2/atoms/Typography/Typography.vue';
import LoyaltyProgram from './Sections/LoyaltyProgram.vue';
import GiftCard from './Sections/GiftCard.vue';
import WelcomeCoins from './Sections/WelcomeCoins.vue';
import Billing from './Sections/Billing.vue';

import { SalesOnboardingFormState } from '@/models/sales-onboarding';

@Component({
  components: {
    TwismLogoIcon,
    Typography,
    LoyaltyProgram,
    GiftCard,
    WelcomeCoins,
    Billing
  }
})
export default class ConfirmYourFeatures extends Vue {
  @Prop() data?: any;
  @Prop({ default: false }) triggerAnimation?: boolean;
  @Prop({ default: false }) welcomeCoinsWithoutCoins?: boolean;
  @Prop({ default: false }) loyaltyWithoutSettings?: boolean;

  formData = {};

  get totalLocations() {
    return this.data.locations.length;
  }

  get loyaltyData() {
    const { loyaltyRewards } = this.salesOnboardingFormData;

    return loyaltyRewards;
  }

  get salesOnboardingFormData() {
    return this.$store.getters[
      'salesOnboarding/getFormData'
    ] as SalesOnboardingFormState;
  }
}
